<template>
    <div
        class="bg-primary-5 flex items-center gap-8"
        :class="{'rounded': !square}"
    >
        <svg-icon v-if="!noIcon" type="search" class="w-18 h-18 fill-primary ml-16" />
        <input
            ref="input"
            :id="staticId ? staticId : 'search' + _uid"
            :autofocus="autofocus"
            :placeholder="placeholder || $t('general.search')"
            v-model="inputValue"
            type="search"
            class="text-primary placeholder-primary text-body-sm bg-transparent w-full ring-0 outline-0 py-12"
            :class="noIcon ? 'px-16' : 'pr-16'"
            @escape="clear"
            @blur="$emit('input-blur')"
            @focus="$emit('input-focus')"
            @click="$emit('input-click')"
            @keydown.up.prevent="$emit('move-up')"
            @keydown.down.prevent="$emit('move-down')"
            @keydown.enter.prevent="$emit('enter')"
            @keydown.escape="$emit('escape')"
        >
        <button v-if="!noDelete" role="button" @click="cancelSearch">
            <svg-icon
                v-if="value"
                type="cancel"
                class="fill-primary-80 hover:fill-semantic-error mr-12 transition-colors"
            />
        </button>
        <button
            v-if="actionButtonText"
            class="first-letter:uppercase self-stretch px-12 flex items-center justify-center gap-8 flex-none cursor-pointer bg-secondary hover:bg-secondary-80 text-white"
            role="button"
            @click="$emit('action')"
        >
            {{ capitaliseFirst(actionButtonText) }}
            <svg-icon v-if="actionButtonIcon" :type="actionButtonIcon" class="w-18 h-18" />
        </button>
        <slot/>
    </div>
</template>

<script>
import Input from '../forms/Input.vue';
import SvgIcon from './SvgIcon.vue';
import RoundButton from "./RoundButton.vue";
import {ucfirst} from "../../../shared/helpers";

export default {
    components: {
        RoundButton,
        'simple-input': Input,
        SvgIcon,
    },
    props: {
        staticId: String|Number,
        value: String,
        placeholder: {
            type: String,
        },
        autofocus: {
            type: Boolean,
            default: true,
        },
        noIcon: Boolean,
        noDelete: Boolean,
        actionButtonText: String,
        actionButtonIcon: String,
        square: Boolean,
    },
    computed: {
        inputValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        capitaliseFirst(text = '') {
            return ucfirst(text);
        },
        cancelSearch() {
            this.clear();
            this.$refs.input.focus();
        },
        clear() {
            this.inputValue = '';
        },
    },
    mounted() {
        this.$refs.input.focus();
    }
};
</script>

<style>
.custom-search input[type=search] {
    &::-webkit-search-results-decoration,
    &::-webkit-search-results-button,
    &::-webkit-search-cancel-button,
    &::-webkit-search-decoration {
      -webkit-appearance: none;
  }
}
</style>
